import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { LogService } from './services/log.service';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SidenavListComponent } from './components/sidenav-list/sidenav-list.component';
import { MatListModule } from '@angular/material/list';
import { LandingGeneralModule } from './pages/landing-general/landing-general.module';
import { FooterComponent } from './components/footer/footer.component';
import { initializeKeycloak } from './utils/keycloak.init';
import { ModalProcessComponent } from './components/modal-process/modal-process.component';
import { ComponentsModule } from './pages/buro/components/components.module';
import { environment } from 'src/environments/environment';
import { WhatsComponent } from './components/whats/whats.component';
import { DEBUG_MODE } from '@angular/fire/compat/analytics';
import { TokenInterceptor } from './utils/token.interceptor';
import { DirectivesModule } from './directives/directives.module';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';

import { MissingDataRegisterComponent } from './components/missing-data-register/missing-data-register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TokenCustomInterceptor } from './utils/token.custom.interceptor';
import { checkInitToken } from './utils/token.init';
import { UserModifiedInterceptor } from './utils/user.interceptor';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { MatGridListModule } from '@angular/material/grid-list';





const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.cookies.domain,
  },
  position: 'bottom',
  theme: 'classic',
  palette: {
    popup: {
      background: '#75787b',
      text: '#ffffff',
      link: '#ffffff',
    },
    button: {
      background: '#fe5000',
      text: '#ffffff',
      border: 'transparent',
    },
  },
  type: 'info',
  content: {
    message:
      'Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrar publicidad relacionada con tus preferencias. Si continuas navegando, consideramos que aceptas su uso.',
    dismiss: 'Acepto',
    link: 'Leer más',
    href: `${environment.keycloak.redirectUri}/landing#politica-cookies`,
  },
};

@NgModule({
  declarations: [
    AppComponent,
    MainHeaderComponent,
    SidenavListComponent,
    FooterComponent,
    ModalProcessComponent,
    WhatsComponent,
    MissingDataRegisterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
        },
        deps: [HttpClient],
      },
    }),
    KeycloakAngularModule,
    MatToolbarModule,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,
    MatMenuModule,
    MatSidenavModule,
    FlexLayoutModule,
    MatListModule,
    LandingGeneralModule,
    ComponentsModule,
    DirectivesModule,
    MatGridListModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    ReactiveFormsModule,
    MatDialogModule,
    TourMatMenuModule.forRoot(),
  ],
  providers: [
    LogService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenCustomInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserModifiedInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: checkInitToken,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    {
      provide: 'googleTagManagerId',
      useValue: environment.gtm.googleTagManagerId,
    },
    // MODO DEBUG SOLO PARA DESARROLLO, ELIMINAR EN PROYECTO REAL
    { 
      provide: DEBUG_MODE, 
      useValue: !environment.production 
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
